import {buildModalInitialValues} from '../../core/modalCommand';
import {trackActiveAgentExperience} from '../../core/experienceLifecycle';
import {AP_EDIT_EXPERIENCE_EVENT} from './events';

/**
 * Open the inline Access Point identity editor.
 * @param {object} command experience command
 * @param {object} envelope request correlation
 * @return {Promise<void>} experience acknowledgement
 */
export function openAccessPointEditExperience(command, envelope) {
	return new Promise((resolve, reject) => {
		const timer = setTimeout(
			() => reject(new Error('access_point_experience_timeout')),
			5000,
		);
		window.dispatchEvent(new CustomEvent(AP_EDIT_EXPERIENCE_EVENT, {
			detail: {
				entityId: command.params?.entity_id,
				initialValues: buildModalInitialValues(command.params),
				open: (close) => {
					clearTimeout(timer);
					trackActiveAgentExperience({
						request_id: envelope.request_id,
						command_id: command.command_id,
						session_id: envelope.session_id,
						workflow_instance_id: command.workflow_instance_id,
						workflow_revision: command.workflow_revision,
						idempotency_key: command.idempotency_key,
					}, close);
					resolve();
				},
				fail: () => {
					clearTimeout(timer);
					reject(new Error('access_point_experience_failed'));
				},
			},
		}));
	});
}
